module.exports = __webpack_public_path__ + "static/media/icon_93.866315b3.svg";